export default {
    info: {
        className: 'alert-primary',
        message: `Component description goes here`,
    },
    tabs: {
        settings: {
            label: 'Settings',
            fields: {

            }
        },
        info: {
            label: 'Info',
            fields: {
                title: {
                    name: 'info[title]',
                    type: 'text',
                    label: 'Title',
                    wrapper: 'form-group',
                    className: 'form-control',
                    placeholder: 'Type an descriptive title',
                    required: false,
                },
                description: {
                    name: 'info[description]',
                    type: 'textarea',
                    label: 'Description',
                    wrapper: 'form-group',
                    className: 'form-control',
                    placeholder: 'Type a short description',
                    required: false,
                },
            }
        }
    },
    buttons: {
        save: {
            className: 'btn btn-sm btn-primary icon-left mt-2 me-2',
            label: 'Save',
            type: 'submit'
        }
    }
}